import * as $ from 'jquery';
import { ToastrService } from 'ngx-toastr';
import { Component, OnInit, HostListener, ViewChild, OnDestroy } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { MasterConstants } from './../../../common/constants/master-constants';
import { BroadcastService } from './../../../services/infrastructure/broadcaster.service';
import { ConfigService } from './../../../services/infrastructure/config.service';
import { SeedReturnService } from './../../../services/seed/seed-return.service';
import { SeedReturnAddProductSliderModelService } from '../seed-return-add-product/seed-return-product-slider-model.service';
import { LoaderService } from './../../../services/infrastructure/loader.service';
import { Subscription } from 'rxjs';
import { SeedReturnFilterComponent } from '../seed-return-filter/seed-return-filter.component';
import { ExcelService } from './../../../services/infrastructure/excel.service';

@Component({
  selector: 'app-seed-return-add-product',
  templateUrl: './seed-return-add-product.component.html',
  styleUrls: ['./seed-return-add-product.component.scss']
})

export class SeedReturnAddProductComponent implements OnInit, OnDestroy {
  @ViewChild(SeedReturnFilterComponent) seedReturnFilter: SeedReturnFilterComponent;
  productList: any;
  parentProductList: any;
  tabProductList: any;
  headerCompany = MasterConstants.US_COMPANYCODE;
  productAllDataSource: any;
  parentAccountDataSource: any;
  isProductNotAdded = true;
  subscription = new Subscription();
  selectedProductList = new Array();
  itemList = new Array();
  filterTypeList = new Array();
  displayedColumns: string[] = [];
  manualDisplayedColumns: string[] = this.returnRequestService.isReturnTypeForInnoculant ? ['Product Name', 'Pack Size', 'Technology', 'Treatment', 'Product Line'] : ['Product Name', 'Pack Size', 'Technology', 'Treatment', 'Product Line', 'LotNumber'];
  lotNumber: any;
  manualProductItem: any;
  manualProductItemDesc: any;
  isShipToNonReturnable = false;
  isParentNonReturnable = false;
  allManualDropdownList: any = [];
  allLotMasterList: any = [];
  private selectedTabIndex = 0;
  private currentProductLineId: string;
  private soyabeanProductLineId: string = this.returnRequestService.getProductLineIdByValue(MasterConstants.PRODUCT_LINE_SOYBEAN);
  isReturnTypeForInnoculant: boolean = this.returnRequestService.isReturnTypeForInnoculant;
  existingMarketingBrand: string = null;
  constructor(
    public broadcastService: BroadcastService,
    public configService: ConfigService,
    private toastrService: ToastrService,
    private seedReturnAddProductSliderModelService: SeedReturnAddProductSliderModelService,
    private loaderService: LoaderService,
    private returnRequestService: SeedReturnService,
    public excelService: ExcelService) {
  }

  // ngOnInit
  ngOnInit() {
    this.subscription.add(this.seedReturnAddProductSliderModelService.existingDataMarketingBrand.subscribe(value => {
      this.existingMarketingBrand = value;
    }))
    this.filterTypeList = [
      { label: 'Product Name', column: 'productName' },
      { label: 'Marketing Brand', column: 'marketingBrand' },
      { label: 'Package Size', column: 'packageSize' },
      { label: 'Seed Size', column: 'seedSize' },
      { label: 'Technology', column: 'technology' },
      { label: 'Treatment', column: 'treatment' },
      { label: 'Item Number', column: 'itemNumber' },
      { label: 'Lot Number', column: 'lotNumber' }
    ];

    this.getInvoicedProduct();
  }

  showShipToNonReturnableProducts(isChecked) {
    this.isShipToNonReturnable = isChecked;

    if (isChecked) {
      this.productAllDataSource = new MatTableDataSource(this.productList);
    }
    else {
      const filteredList = this.productList.filter(x => x.displayMessage == null);
      this.productAllDataSource = new MatTableDataSource(filteredList);
    }
  }

  // search in master search area
  public filterSearchFn(term: string, item: any) {
    term = term.toLocaleLowerCase();
    return item.itemDescription.toLocaleLowerCase().indexOf(term) > -1;
  }

  showParentNonReturnableProducts(isChecked) {
    this.isParentNonReturnable = isChecked;
    if (isChecked) {
      this.parentAccountDataSource = new MatTableDataSource(this.parentProductList);
    }
    else {
      const filteredList = this.parentProductList.filter(x => x.displayMessage == null);
      this.parentAccountDataSource = new MatTableDataSource(filteredList);
    }
  }

  // Search the account details on shipto / Deliverto dropdown
  productSearchFn(term: string, item: any) {
    term = term.toLocaleLowerCase();
    return item.itemDescription.toLocaleLowerCase().indexOf(term) > -1
      || item.itemNumber.toLocaleLowerCase().indexOf(term) > -1;
  }

  // Selected product will add on order
  addSelectedProductToOrder() {
    const data = [];
    if (this.selectedProductList.length > 0) {// Addition use case implemented asked in bug 74741
      this.selectedProductList.forEach(x => {
        const duplicateData = data.find(y => y.itemNumber == x.itemNumber && y.lotNumber == x.lotNumber);
        if (duplicateData) {
          if (!duplicateData.isParent) {
            if (x.isParent) {
              var index = data.indexOf(duplicateData);
              if (index !== -1) {
                data.splice(index, 1);
              }
              data.push(x);
            }
            else if (!x.isParent && !x.isManualLine) {
              var index = data.indexOf(duplicateData);
              if (index !== -1) {
                data.splice(index, 1);
              }
              data.push(x);
            }
          }
        } else {
          data.push(x);
        }
      });

      this.broadcastService.broadcast(this.configService.DATA_CHANGE, { productCount: data.length });
    }
    this.seedReturnAddProductSliderModelService.setData<SeedReturnAddProductSliderModelService[]>(data);
    this.seedReturnAddProductSliderModelService.seedReturnClose();
  }

  getInvoicedProduct() {
    this.loaderService.setLoaderStatus(true);

    const filters = {
      accountNumber: this.returnRequestService.getSelectedAccountNo(),
      productLine: ''
    };

    this.subscription.add(this.returnRequestService.SelectedProductLineId.subscribe(s => {
      filters.productLine = s;
      this.currentProductLineId = s;
      this.setDisplayedColumns(s);
    }));

    this.subscription.add(this.returnRequestService.getInvoicedProductItems(filters).subscribe((result: any) => {
      if (result) {
        this.tabProductList = result;// .filter((v, i, a) => a.findIndex(t => (t.itemId === v.itemId && t.lotNumber === v.lotNumber)) === i)

        this.productList = this.tabProductList.filter(x => x.isParent == false);
        this.productAllDataSource = new MatTableDataSource(this.productList);

        this.parentProductList = this.tabProductList.filter(x => x.isParent == true);
        this.parentAccountDataSource = new MatTableDataSource(this.parentProductList);
        this.showShipToNonReturnableProducts(false);
        this.showParentNonReturnableProducts(false);

        this.setAccInvProdTableHeight();
        this.setcompInvProdTableHeight();

        this.loaderService.setLoaderStatus(false);
      }
    }));
  }

  // Enable or disable Add product to order btn based on item selection
  enableDisableAddProductBtn() {
    if (this.selectedProductList.length > 0) {
      let errorExist = false;
      this.selectedProductList.forEach(x => {
        if (x.lineErrors?.errors?.length > 0) {
          errorExist = true;
          this.isProductNotAdded = true;
        }
      })
      if (!errorExist) {
        this.isProductNotAdded = false;
      }
    }
    else {
      this.isProductNotAdded = true;
    }
  }

  // Get all product based on filter
  getAllProducts(filters) {
    this.loaderService.setLoaderStatus(true);
    const itemNo = filters.itemNo ? filters.itemNo.split(',').map(item => item.trim()) : [];
    const lotNumber = filters.lotNumber ? filters.lotNumber.split(',').map(item => item.trim()) : [];
    const invoiceNumber = filters.invoiceNumber ? filters.invoiceNumber.split(',').map(item => item.trim()) : [];

    const productName = filters.productName ? filters.productName.split(',').map(item => item.trim().toLowerCase()) : [];
    const treatment = filters.treatment ? filters.treatment.split(',').map(item => item.trim()) : [];
    const technology = filters.technology ? filters.technology.split(',').map(item => item.trim()) : [];
    const packageSize = filters.packageSize ? filters.packageSize.split(',').map(item => item.trim()) : [];
    const seedSize = filters.seedSize ? filters.seedSize.split(',').map(item => item.trim()) : [];
    const marketingBrand = filters.marketingBrand ? filters.marketingBrand.split(',').map(item => item.trim()) : [];

    if (itemNo.length == 0 && lotNumber.length == 0 && invoiceNumber.length == 0 && packageSize.length == 0 && seedSize.length == 0
      && productName.length == 0 && marketingBrand.length == 0 && technology.length == 0 && treatment.length == 0) {
      this.productList = this.tabProductList.filter(x => x.isParent == false);
      this.parentProductList = this.tabProductList.filter(x => x.isParent == true);
    }
    else {
      this.productList = this.tabProductList.filter(x => x.isParent == false && (itemNo.length == 0 || itemNo.includes(x.itemNumber))
        && (lotNumber.length == 0 || lotNumber.includes(x.lotNumber.trim()))
        && (productName.length == 0 || (x.itemDescription.trim().toLowerCase()).includes(productName)) && (marketingBrand.length == 0 || marketingBrand.includes(x.marketingBrand))
        && (packageSize.length == 0 || packageSize.includes(x.packageSizeDesc.trim()))
        && (seedSize.length == 0 || seedSize.includes(x.seedSize.trim()))
        && (technology.length == 0 || x.technology.includes(technology))
        // && (technology.length == 0 || (x.technology.trim().toLowerCase()).includes(technology))
        && (treatment.length == 0 || treatment.includes(x.treatmentDescription)));

      this.parentProductList = this.tabProductList.filter(x => x.isParent == true && (itemNo.length == 0 || itemNo.includes(x.itemNumber))
        && (lotNumber.length == 0 || lotNumber.includes(x.lotNumber.trim()))
        && (productName.length == 0 || (x.itemDescription.trim().toLowerCase()).includes(productName)) && (marketingBrand.length == 0 || marketingBrand.includes(x.marketingBrand))
        && (packageSize.length == 0 || packageSize.includes(x.packageSizeDesc))
        && (seedSize.length == 0 || seedSize.includes(x.seedSize.trim()))
        && (technology.length == 0 || x.technology.includes(technology))
        // && (technology.length == 0 || (x.technology.trim().toLowerCase()).includes(technology))
        && (treatment.length == 0 || treatment.includes(x.treatmentDescription)));
    }

    this.productList.forEach(x => {
      if (this.selectedProductList.filter(y => y.itemNumber.trim() == x.itemNumber.trim() && y.lotNumber.trim() == x.lotNumber.trim() && !x.isParent).length > 0) {
        x.IsProductSelected = true;
      }
      else {
        x.IsProductSelected = false;
      }
    });
    this.parentProductList.forEach(x => {
      if (this.selectedProductList.filter(y => y.itemNumber == x.itemNumber && y.lotNumber == x.lotNumber && x.isParent).length > 0) {
        x.IsProductSelected = true;
      }
      else {
        x.IsProductSelected = false;
      }
    });
    if (this.productList.length === 0 && this.parentProductList.length === 0) {
      this.toastrService.error('No record(s) found for the selected search criteria');
    }
    this.showShipToNonReturnableProducts(this.isShipToNonReturnable);
    this.showParentNonReturnableProducts(this.isParentNonReturnable);

    this.enableDisableAddProductBtn();
    this.loaderService.setLoaderStatus(false);
  }

  // Filter Product GridData based on filter values
  filterProductGridData(filters) {
    if (filters.clearAll == false) {
      this.getAllProducts(filters);
    }
    else {
      this.productList = [];
      this.productAllDataSource = new MatTableDataSource(this.productList);
      this.parentProductList = [];
      this.parentAccountDataSource = new MatTableDataSource(this.parentProductList);
      filters.clearAll = false;

      const filter: any = {};

      this.getAllProducts(filter);
    }
    this.enableDisableAddProductBtn();
  }

  // Update selected prodcut list
  keepRecords(product, isProductTab) {
    if (product.displayMessage == null && product.invoiceUnits - product.totalReturnUnits > 0) {
      product.IsProductSelected = !product.IsProductSelected;
      const itemNumber = product.itemNumber;
      const lotNumber = product.lotNumber;
      const marketingBrandID = product.marketingBrandID;
      const isParent = product.isParent;
      if (!product.IsProductSelected) {
        product.lineErrors = { errors: [] };
      }

      if (product.IsProductSelected) {
        this.itemList.push({ 'itemNumber': itemNumber, 'lotNumber': lotNumber, 'isUserAccountInvoiceTab': isProductTab, 'marketingBrandID': marketingBrandID });
        let item;
        if (isProductTab) {
          item = this.productList.filter(i => i.itemNumber == itemNumber && i.lotNumber == lotNumber && i.isParent == isParent);
        } else {
          item = this.parentProductList.filter(i => i.itemNumber == itemNumber && i.lotNumber == lotNumber && i.isParent == isParent);
        }
        this.selectedProductList.push(item[0]);
      }
      else {
        let index = this.itemList.findIndex(x => x.itemNumber == itemNumber && x.lotNumber == lotNumber);
        if (index !== -1) {
          this.itemList.splice(index, 1);
        }
        index = this.selectedProductList.findIndex(x => x.itemNumber == itemNumber && x.lotNumber == lotNumber);
        if (index !== -1) {
          this.selectedProductList.splice(index, 1);
        }
      }
      const diffBrandProductExist = this.checkMarketingBrand(product);
      if (diffBrandProductExist && product.IsProductSelected) {
        product.lineErrors = { errors: [] };
        product.lineErrors.errors.push('Only one seed brand can be on a return, please unselect the line.');
      } else if (!diffBrandProductExist && this.selectedProductList) {
        if (!this.checkMarketingBrand(product)) {
          this.selectedProductList.forEach(product => {
            product.lineErrors = { errors: [] };
          });
        }
      }
      this.enableDisableAddProductBtn();
    }
  }

  checkMarketingBrand(productData) {
    const marketingBrand = productData.marketingBrand;
    let diffMarketingBrandExist = false;
    if (productData.IsProductSelected) {
      this.selectedProductList.forEach((value) => {
        if (value.marketingBrand != marketingBrand) {
          diffMarketingBrandExist = true;
        } else if (this.existingMarketingBrand !== null && this.existingMarketingBrand != value.marketingBrand) {
          diffMarketingBrandExist = true;
        }
      });
    } else if (!productData.IsProductSelected) {
      let _marketingBrand = this.selectedProductList[0].marketingBrand;
      this.selectedProductList.forEach((value) => {
        if (value.marketingBrand != _marketingBrand) {
          diffMarketingBrandExist = true;
        } else if (this.existingMarketingBrand !== null && this.existingMarketingBrand != value.marketingBrand) {
          diffMarketingBrandExist = true;
        }
      });
    }
    return diffMarketingBrandExist;
  }

  resetErrorListMessage(isUserAccountInvoiceTab) {
    if (isUserAccountInvoiceTab) {
      const selectedProduct = this.productAllDataSource.data.filter(i => i.IsProductSelected);
      if (selectedProduct.length == 1) {
        selectedProduct[0].lineErrors = { errors: [] };
      }
    } else {
      const selectedProduct = this.parentAccountDataSource.data.filter(i => i.IsProductSelected);
      if (selectedProduct.length == 1) {
        selectedProduct[0].lineErrors = { errors: [] };
      }
    }
  }

  // Tab changed
  tabChanged = (tabChangeEvent: MatTabChangeEvent): void => {
    this.selectedTabIndex = tabChangeEvent.index;

    if (this.selectedTabIndex === 0) {
      this.setAccInvProdTableHeight();
    } else if (this.selectedTabIndex === 1) {
      this.setcompInvProdTableHeight();
    } 
  };

  // set Add product table height
  setAccInvProdTableHeight() {
    const tableHeight = window.innerHeight - $('.prod-top-sec').outerHeight() - $('.mat-mdc-tab-header').outerHeight() - $('.add-order-sec').outerHeight() - 65;
    $('.seed-return-add-prod .accInvProdTable').css('max-height', tableHeight + 'px');
  }

  setcompInvProdTableHeight() {
    const tableHeight = window.innerHeight - $('.prod-top-sec').outerHeight() - $('.mat-mdc-tab-header').outerHeight() - $('.add-order-sec').outerHeight() - 65;
    $('.seed-return-add-prod .compInvProdTable').css('max-height', tableHeight + 'px');
  }

  // Added Window onresize
  @HostListener('window:resize', ['$event']) onresize(event) {
    this.setAccInvProdTableHeight();
    this.setcompInvProdTableHeight();
  }

  // ngOnDestroy
  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  private setDisplayedColumns(productLine: string) {
    const seekColumnsProductLines: Array<string> = [
      this.returnRequestService.getProductLineIdByValue(MasterConstants.PRODUCT_LINE_CORN),
      this.returnRequestService.getProductLineIdByValue(MasterConstants.PRODUCT_LINE_SUNFLOWEROIL)
    ];

    if (seekColumnsProductLines.includes(productLine)) {
      this.manualDisplayedColumns.splice(2, 0, 'Seed Size');
    }

    this.displayedColumns = JSON.parse(JSON.stringify(this.manualDisplayedColumns));
    this.displayedColumns.splice(1, 0, 'Eligible Units');
  }

  public export() {
    const exportData = [];
    this.loaderService.setLoaderStatus(true);

    if (this.selectedTabIndex === 0 && this.productList && this.productList.length > 0) {
      const filteredList = this.productList.filter(x => x.displayMessage == null);
      filteredList.forEach(x => {
        exportData.push({
          'Account Number': x.shipToAccount,
          'Account Name': x.shipToAccountAccountName,
          'Product Number': x.itemNumber,
          'Product Name': `${x.itemVendorName}/${x.itemDescription}`,
          'Pack Size': x.packageSizeDesc,
          'Technology': x.technology,
          'Treatment': x.treatmentDescription,
          'Product Line': x.productLine,
          'Lot Number': x.lotNumber,
          'Eligible Return Quantity': x.invoiceUnits - x.totalReturnUnits > 0 ? x.invoiceUnits - x.totalReturnUnits : 0
        });
      });
      this.excelService.exportAsExcelFile(exportData, `Account_${this.returnRequestService.getProductLineTextById(this.returnRequestService.SelectedProductLineId.getValue())}_Products`);
    } else if (this.selectedTabIndex === 1 && this.parentProductList && this.parentProductList.length > 0) {
      const filteredList = this.parentProductList.filter(x => x.displayMessage == null);
      filteredList.forEach(x => {
        exportData.push({
          'Account Number': x.parentAccount,
          'Account Name': x.parentAccountAccountName,
          'Product Number': x.itemNumber,
          'Product Name': `${x.itemVendorName}/${x.itemDescription}`,
          'Pack Size': x.packageSizeDesc,
          'Technology': x.technology,
          'Treatment': x.treatmentDescription,
          'Product Line': x.productLine,
          'Lot Number': x.lotNumber,
          'Eligible Return Quantity': x.invoiceUnits - x.totalReturnUnits > 0 ? x.invoiceUnits - x.totalReturnUnits : 0
        });
      });
      this.excelService.exportAsExcelFile(exportData, `Parent_${this.returnRequestService.getProductLineTextById(this.returnRequestService.SelectedProductLineId.getValue())}_Products`);
    }

    this.loaderService.setLoaderStatus(false);
  }

  public isDisableExportButton(): boolean {
    let retVal = true;

    if (this.selectedTabIndex === 0 && this.productList) {
      retVal = this.productList.filter(x => x.displayMessage == null).length === 0;
    } else if (this.selectedTabIndex === 1 && this.parentProductList) {
      retVal = this.parentProductList.filter(x => x.displayMessage == null).length === 0;
    }

    return retVal;
  }

  public isShowExportButton(): boolean {
    return [0, 1].includes(this.selectedTabIndex) && this.currentProductLineId !== this.soyabeanProductLineId;
  }
}
